import { Link } from 'react-router-dom';
import { Theme } from '@aws-amplify/ui-react';
import { ACCOUNT_FIELDS } from './constantsHelper';
import Info from 'components/Info/Info';
import { GROUP_NAMES } from 'utils';
import i18next from 'i18next';

export const generateNavOptions = (handleOnClick: () => void, userGroups: string[]) => {
  const infoHeader = <span>{`${t('pages.pickInsights.headerText')}`}</span>;
  const infoBody = (
    <div>
      <div className={'info__text'}>{`${t('pages.pickInsights.freeInfoText')}`}</div>
    </div>
  );
  const isEliteUser = userGroups.includes(GROUP_NAMES.elite);
  const pickInsightsContent = !isEliteUser ? (
    <div className={`nav__option disabled`}>
      <Info
        header={infoHeader}
        body={infoBody}
        iconHoverElement={
          <Link className="insights" to={''} onClick={() => null}>
            <span className="title">{`${t('nav.pickInsights')}`}</span>
            <span className="nav__badge">{`${t('nav.badges.elite')} only`}</span>
          </Link>
        }
      />
    </div>
  ) : isEliteUser ? (
    <div className={`nav__option`}>
      <Link
        className="insights"
        to={'/insights'}
        onClick={() => (isEliteUser ? handleOnClick() : null)}
      >
        {`${t('nav.pickInsights')}`}
        <span className="nav__badge">{`${t('nav.badges.elite')}`}</span>
      </Link>
    </div>
  ) : null;
  const todaysInfoHeader = <span>{`${t('pages.todaysPick.headerText')}`}</span>;
  const todaysInfoBody = (
    <div>
      <div className={'info__text'}>{`${t('pages.todaysPick.freeInfoText')}`}</div>
    </div>
  );
  const todaysPickContent = !isEliteUser ? (
    <div className={`nav__option disabled`}>
      <Info
        header={todaysInfoHeader}
        body={todaysInfoBody}
        iconHoverElement={
          <Link className="insights" to={''} onClick={() => null}>
            <span className="title">{`${t('nav.todaysPick')}`}</span>
            <span className="nav__badge">{`${t('nav.badges.elite')} only`}</span>
          </Link>
        }
      />
    </div>
  ) : isEliteUser ? (
    <div className={`nav__option`}>
      <Link
        className="insights"
        to={'/todays-lock'}
        onClick={() => (isEliteUser ? handleOnClick() : null)}
      >
        {`${t('nav.todaysPick')}`}
        <span className="nav__badge">{`${t('nav.badges.elite')}`}</span>
      </Link>
    </div>
  ) : null;
  const ourBetInfoHeader = <span>{`${t('pages.ourBet.headerText')}`}</span>;
  const ourBetInfoBody = (
    <div>
      <div className={'info__text'}>{`${t('pages.ourBet.freeInfoText')}`}</div>
    </div>
  );
  const ourBetContent = !isEliteUser ? (
    <div className={`nav__option disabled`}>
      <Info
        header={ourBetInfoHeader}
        body={ourBetInfoBody}
        iconHoverElement={
          <Link className="insights" to={''} onClick={() => null}>
            <span className="title">{`${t('nav.ourBet')}`}</span>
            <span className="nav__badge">{`${t('nav.badges.elite')} only`}</span>
          </Link>
        }
      />
    </div>
  ) : isEliteUser ? (
    <div className={`nav__option`}>
      <Link
        className="insights"
        to={'/our-bet'}
        onClick={() => (isEliteUser ? handleOnClick() : null)}
      >
        {`${t('nav.ourBet')}`}
        <span className="nav__badge">{`${t('nav.badges.elite')}`}</span>
      </Link>
    </div>
  ) : null;

  return [
    {
      id: 'homeNav',
      content: (
        <div className="nav__option">
          <Link to={'/home'} onClick={() => handleOnClick()}>{`${t('nav.home')}`}</Link>
        </div>
      ),
    },
    {
      id: 'pricingNav',
      content: (
        <div className="nav__option">
          <Link to={'/pricing'} onClick={() => handleOnClick()}>{`${t('nav.pricing')}`}</Link>
        </div>
      ),
    },
    {
      id: 'picksNav',
      content: (
        <div className="nav__option">
          <Link to={'/picks'} onClick={() => handleOnClick()}>{`${t('nav.picks')}`}</Link>
        </div>
      ),
    },
    {
      id: 'ourBetNav',
      content: ourBetContent,
    },
    {
      id: 'pickInsightsNav',
      content: pickInsightsContent,
    },
    {
      id: 'todaysPickNav',
      content: todaysPickContent,
    },
    {
      id: 'myAccountNav',
      content: (
        <div className="nav__option">
          <Link to={'/account'} onClick={() => handleOnClick()}>{`${t('nav.myAccount')}`}</Link>
        </div>
      ),
    },
    {
      id: 'aboutNav',
      content: (
        <div className="nav__option">
          <Link to={'/about'} onClick={() => handleOnClick()}>{`${t('nav.about')}`}</Link>
        </div>
      ),
    },
    {
      id: 'contactNav',
      content: (
        <div className="nav__option">
          <Link to={'/contact'} onClick={() => handleOnClick()}>{`${t('nav.contact')}`}</Link>
        </div>
      ),
    },
  ];
};

export const t = i18next.t;

export const generateFooterChildren = () => {
  return <div>{`${t('app.footer')}`}</div>;
};

export const generateAuthTheme = (tokens) => {
  const theme: Theme = {
    name: 'authenticator_theme',
    tokens: {
      colors: {
        background: {
          primary: {
            value: tokens.colors.neutral['90'].value,
          },
          secondary: {
            value: tokens.colors.neutral['100'].value,
          },
        },
        font: {
          interactive: {
            value: tokens.colors.white.value,
          },
        },
        brand: {
          primary: {
            '10': tokens.colors.teal['100'],
            '80': tokens.colors.teal['40'],
            '90': tokens.colors.teal['20'],
            '100': tokens.colors.teal['10'],
          },
        },
      },
      components: {
        tabs: {
          item: {
            _focus: {
              color: {
                value: tokens.colors.white.value,
              },
            },
            _hover: {
              color: {
                value: tokens.colors.yellow['80'].value,
              },
            },
            _active: {
              color: {
                value: tokens.colors.white.value,
              },
            },
          },
        },
      },
    },
  };
  return theme;
};

export const generateDefaultAccountFieldMap = (user) =>
  Object.keys(ACCOUNT_FIELDS).reduce((acc, key) => {
    acc[key] = '';
    if (key === ACCOUNT_FIELDS.email.id) {
      acc[key] = user?.attributes?.email;
    }
    if (key === ACCOUNT_FIELDS.firstname.id) {
      acc[key] = '';
    }
    if (key === ACCOUNT_FIELDS.lastname.id) {
      acc[key] = '';
    }
    if (key === ACCOUNT_FIELDS.phone.id) {
      acc[key] = '';
    }
    return acc;
  }, {});
